import O1HD from "../../../../engines/gameEngine";


// 本地数据基类
export class BaseLocalDataInfos {
    // 存储数据
    saveLocalData() {
        let key = this.getLocalDataKey();
        let saveData = JSON.stringify(this);
        O1HD.getServices().localStorageSrv.setStorage(key, saveData);
    }

    // 加载数据
    loadLocalData() {
        let key = this.getLocalDataKey();
        let strdata = O1HD.getServices().localStorageSrv.getStorage(key);
        if (strdata) {
            let data = JSON.parse(strdata);
            Object.assign(this, data);
        }
    }

    /**
     * 删除数据
     * @param key 
     */
    deleteLocalData() {
        // let key = this.getLocalDataKey();
    }

    getLocalDataKey() {
        return '';
    }
}
